<!-- <div class=" p-4    rounded-xl prod-card min-h-[440px] relative md:min-w-[300px] min-w-[330px] w-full animate__animated animate__bounceIn "> -->
<!-- matRipple [matRippleColor]="'#00000077'" [matRippleUnbounded]="true"  [matRippleRadius]="200" [matRippleCentered]="true" -->
<!-- <div [id]="item.id" class="w-full h-full flex"> -->



<a mat-list-item #divToDownload [routerLink]="['/', item.category!.slug! + '', item.slug + '_' + item.id]"
	[state]="item" [ariaLabel]="item.label" (mouseenter)="playAudio()" (mousemove)="playAudio()"
	(mouseover)="playAudio()" (touchstart)="playAudio()" (mouseleave)="stopAnim()"
	class="p-4 rounded-xl prod-card min-h-[440px] relative md:min-w-[280px] min-w-[330px] w-full animate__animated animate__bounceIn magicpattern">
	<span *ngIf="item.newArrival" [ngClass]="{ '!bg-yellow-300': !isSS }"
		class="text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 new"
		style="position: absolute; top: -4px; right: 18px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Latest Additon</span>


	<span *ngIf="item.discounted" [ngClass]="{ '!bg-red-600': !isSS }"
		class="text-yellow-400 text-xs font-medium ms-2 px-2.5 py-0.5 discount relative "
		style="position: absolute; top: -4px; left: 18px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
			class="  ">
			{{getPercentage()}}%</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>




	<img [src]="'../../../../assets/icons/koko'+kokoicon+'.png'"
		style="width: 100px; top: -60px; position: absolute; transform: rotate(-20); z-index: 9999999px;" class="koko">

	<div class=" " *ngIf="false" style="
				left: 0;
				top: 0;
				right: 0; 
				z-index: 1 !important;
				border-radius: inherit;
				background-clip: padding-box;
				height: 100%;
				width: 100%;

			">
		<video [src]="src" *ngIf="!stop" preload id="myVideo" class="vid" #videoPlayer style="
					height: 100%;
					width: 100%;
					object-fit: cover;
					object-position: center;
					left: 0;
					top: 0;
					right: 0;
					border-radius: inherit;
					background-clip: padding-box;
					filter: saturate(3);
				" autoplay muted loop playsinline webkit-playsinline disablePictureInPicture></video>
	</div>

	<video [src]="src" *ngIf="!stop" preload id="myVideo" class="vid" #videoPlayer style="
					height: 100%;
					width: 100%;
					object-fit: cover;
					object-position: center;
					left: 0;
					top: 0;
					right: 0;
					border-radius: inherit;
					background-clip: padding-box;
					filter: saturate(3);
				" autoplay muted loop playsinline webkit-playsinline disablePictureInPicture></video>

	<div class="flex flex-col m-6 p-4 backdrop-blur-sm rounded-xl tint relative cart" style="
				z-index: 2 !important;
				position: absolute;
				top: 0;
				right: 0;
				left: 0;
				bottom: 0;
			">
		<div class="block   h-48 rounded overflow-hidden icon-img aspect-video relative">
			<img [alt]="item.label" class="object-contain object-center w-full h-full block aspect-video absolute"
				style="filter: saturate(1.8)" loading="lazy" [src]="urlAdjust(item!.icon!)" />
		</div>
		<!-- <small>{{urlAdjust(item!.icon!)}}</small> -->
		<p *ngIf="item.warranty !== undefined && item.warranty !== null" class="text-sm warranty">
			{{ item.warranty | uppercase }}
			<span *ngIf="item.warranty!.length > 0"> WARRANTY</span>
		</p>


		<div *ngIf="item.availability === 'PRE_ORDER' || item.availability === 'PRE_ORDER_PRICE_MAY_VARY' "
			[ngClass]="{ '!bg-yellow-300': !isSS }"
			class="text-red-800 w-full text-xs rounded-md font-medium me-2 px-2.5 py-0.5 text-center">
			<span>Early Reservation Only</span>
		</div>

		<div *ngIf="item.availability === 'IN_STOCK' || item.availability === 'IN_STOCK_PRICE_MAY_VARY'"
			[ngClass]="{ '!bg-yellow-300': !isSS }"
			class="!text-red-800 w-full text-xs rounded-md font-medium me-2 px-2.5 py-0.5 text-center">
			<span>In Supply</span>
		</div>

		<div *ngIf="item.availability === 'OUT_OF_STOCK'" [ngClass]="{ '!bg-red-800': !isSS }"
			class="!text-yellow-300 w-full text-xs rounded-md font-medium me-2 px-2.5 py-0.5 text-center">
			<span>Sold Out</span>
		</div>

		<span class="w-full h-2"></span>

		<!-- <div class="mt-2"> -->
		<!-- [innerHTML]="item!.shortDescription" -->
		<span
			class="text-gray-500 text-[10px] tracking-widest title-font mb-1 des leading-none label-title">{{shortDes}}</span>

		<!-- [ngClass]="{ 'text-black':!isDark}" -->
		<h1 class="   !text-[.85em] font-medium  label-title ">
			{{ item.label }}
		</h1>
		<div class="pt-[2.3px] justify-between w-full flex flex-row items-center">
			<span *ngIf="item.discounted" [ngClass]="{ '!bg-yellow-300': !isSS }"
				class="place-content-center shrink text-red-800 !text-xs font-medium me-2 px-2.5 py-0.5 rounded-full">Exclusive
				Deal</span>

			<span *ngIf="item.brandNew && !item.used" [ngClass]="{ '!bg-red-500': !isSS }"
				class="place-content-center shrink text-amber-400 !text-xs font-medium me-2 px-2.5 py-0.5 rounded-full animate__animated  animate__headShake animate__slower      animate__infinite">Brand
				New</span>
			<span *ngIf="!item.brandNew && item.used" [ngClass]="{ '!bg-orange-400': !isSS }"
				class="place-content-center shrink text-white !text-xs font-medium me-2 px-2.5 py-0.5 rounded-full  ">Used</span>


		</div>
		<div
			class="flex flex-col gap-1 rounded-xl bg-white/80 p-2 mt-2 shadow-sm shadow-black/5 border border-gray-200/70 backdrop-blur-sm mt-2 mb-3 relative">
			<div class="flex items-center justify-between">
				<div class="flex  justify-between items-center gap-2 w-full"
					*ngIf="!item.pleaseContactForPrice && item.availability !== 'IN_STOCK_PRICE_MAY_VARY' && item.availability !== 'PRE_ORDER_PRICE_MAY_VARY'">
					<div class="flex w-1/2">
						<!-- <p class="text-[0.65rem] uppercase tracking-[0.3em] text-gray-500">Best price</p> -->
						<h2 class="!text-[1.3em] font-extrabold text-black !leading-tight">
							{{ item.newPrice | currency : "Rs." : "Rs." : "1.0-0" }}
						</h2>
					</div>
					<div *ngIf="item.discounted" class="flex flex-wrap items-center gap-2 text-sm text-gray-600 w-full">
						<span class="text-red-600 font-bold text-sm">
							<span class="font-semibold text-red-700 align-super">Was </span>
							<span [ngClass]="{ 'line-through': !isSS }" class="text-red-500 !text-[1.3em]">{{
								item.previousPrice | currency : "Rs." : "Rs." : "1.0-0" }}</span>
						</span>
					</div>
				</div>
				<div class=""
					*ngIf="!item.pleaseContactForPrice && (item.availability === 'IN_STOCK_PRICE_MAY_VARY' || item.availability === 'PRE_ORDER_PRICE_MAY_VARY')">
					<h2 class="!text-[1.1em] font-extrabold text-black !leading-tight">
						PLEASE CONTACT FOR PRICE
					</h2>
				</div>
				<div class="flex flex-col w-full cursor-pointer"
					*ngIf="item.pleaseContactForPrice"
					(click)="callNumber('0772553478', $event)">
					<p class="text-[0.65rem] uppercase tracking-[0.2em] text-gray-500 font-semibold">Contact for pricing</p>
					<h2 class="!text-[1.2em] font-extrabold text-red-600 !leading-tight mt-0.5">
						0772553478
					</h2>
				</div>
			</div>
		</div>
	</div>

	<button class="p-4 cart content-center flex flex-row mb-3 mr-3" (click)="
					$event.stopPropagation();
					$event.preventDefault();
					handleLike($event, item.id!)
				" style="position: absolute; bottom: 0px; right: 0px; z-index: 10;">
		<span class="add-to-cart">
			<span class="cart-text !text-[.85em]">Add to Cart</span>
		</span>
		<img src="../../../../assets/graphics/add_shopping_cart_FILL0_wght400_GRAD0_opsz24.svg"
			alt="add to shopping cart" width="24" height="24" loading="eager" />
	</button>
</a>


<!-- <button
	class="p-4 cart content-center flex flex-row"
	(click)="$event.stopPropagation();$event.preventDefault(); handleLike($event)"
	style="position: absolute; bottom: 0px; right: 0px"
>
	<span class="add-to-cart">
		<span class="cart-text">Add to cart</span>
	</span>
	<img
		src="../../../../assets/graphics/add_shopping_cart_FILL0_wght400_GRAD0_opsz24.svg"
		alt="add to shopping cart"
		width="24"
		height="24"
		loading="eager"
	/>
</button> -->

<!-- </div> -->